<template>
  <div
    :class="[
      'project-status overflow-ellipsis',
      color,
      clickable ? 'project-status--clickable' : '',
      multiline ? 'project-status--multiline' : '',
    ]"
    :title="statusText"
    @click="clickElement"
  >
    {{ statusText }}
  </div>
</template>

<script>
export default {
  props: {
    statusText: {
      type: String,
      required: true,
    },
    clickable: {
      type: Boolean,
      required: false,
      default: false,
    },
    multiline: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  computed: {
    color() {
      let statusColorClass = 'project-status--orange';
      if (['zaakceptowany', 'przyjęty', 'zarchiwizowany'].some((s) => this.statusText.toLowerCase().includes(s))) {
        statusColorClass = 'project-status--green';
      } if (this.statusText.toLowerCase().includes('odrzucony')) {
        statusColorClass = 'project-status--red';
      }
      return statusColorClass;
    },
  },

  methods: {
    clickElement() {
      if (this.clickable) this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
  .project-status {
    padding: 8px 16px;
    display:inline-block;
    max-width:100%;
    font-weight:500;
    &--red {
      color:#E25B46;
      background-color:#E25B4610;
    }
    &--green {
      color: #00695F;
      background-color: #00695F10;
    }
    &--orange {
      color: #EA9E36;
      background-color: #CD671D10;
    }
    &--clickable {
      cursor: pointer;
    }
    &--multiline.project-status {
      width: 212px;
      text-overflow: clip;
      font-size: 11px;
      line-height: 13px;
      text-align:center;
      white-space: pre-wrap;
    }
  }
</style>
